// document.addEventListener('cart:updated', function(evt) {
//     console.log('test:',evt.detail.cart);

//     const data = evt.detail.cart
//     const hasTargetProduct = data.items.some(item => 
//         item.product_id == '8280119378111'
//     );
//     if (hasTargetProduct) {
//         addTagToCustomer('NEWMOD260116');
//     } else {
//         removeTagFromCustomer('NEWMOD260116');
//     }
//   });
console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')
document.body.addEventListener('click', function(e) {
  const btn = e.target.closest('.hs-qtybutton') || e.target.closest('.js-qty__adjust');
  if (!btn) return;
  
  e.preventDefault();
  e.stopPropagation();
  
 const cartItem = btn.closest('.hs-cart-plus-minus') || btn.closest('.cart__item');
  if (!cartItem) {
    console.warn('未找到 .cart__item 元素');
    return;
  }
  
  console.log('找到 cart__item:', cartItem)
  // 2. 检查祖父元素的 data-key 是否包含 '123'
  const dataKey = cartItem.dataset.key || '';
  console.log('祖父元素 data-key:', dataKey);
  
  if (!dataKey.includes('44910487240895')) {
    console.log('data-key 不包含 44910487240895');
    return;
  }
  
  // 3. 获取输入框
  const input = cartItem.querySelector('[data-value]') || cartItem.querySelector('.js-qty__num');
  if (!input) {
    console.warn('未找到输入框');
    return;
  }
  
  // 4. 判断是加还是减
  const isIncrease = btn.classList.contains('hs-inc') || 
                    btn.classList.contains('js-qty__adjust--plus') ||
                    btn.textContent.includes('+') ||
                    btn.getAttribute('data-action') === 'increase';
  
  const isDecrease = btn.classList.contains('hs-dec') || 
                     btn.classList.contains('js-qty__adjust--minus') ||
                     btn.textContent.includes('-') ||
                     btn.getAttribute('data-action') === 'decrease';
  

  
  let currentValue = input.dataset.value || parseInt(input.value) || 0;
  console.log('当前值:', currentValue);
  
  // 6. 处理加减操作
  if (isIncrease) {
    // 增加
    console.log('增加操作，新值:', input.value);
    
  } else if (isDecrease) {
    // 减少
    if (currentValue == 0 || input.value  == 0) {
      console.log('减少操作，新值:', input.value);
        removeTagFromCustomer('NEWMOD260116')
    } 
  }
    
});

document.body.addEventListener('click', function (e) {
  const btn = e.target.closest('.cart__remove');
  if (!btn) return;

  e.preventDefault();

  const textLink = btn.querySelector('.text-link');
  if (!textLink) {
    console.warn('未找到 .text-link 子元素');
    return;
  }

  const href = textLink.getAttribute('href') || textLink.href || '';
  console.log('找到链接:', href);

  if (href.includes('44910487240895')) {
    console.log(' href 包含 44910487240895，执行逻辑');
    
    removeTagFromCustomer('NEWMOD260116');
    setTimeout(() => {
      window.location.replace(href);
    }, 1000);

  } else {
    console.log(' href 不包含 123，跳过');
  }
});

function addTagToCustomer(tagToAdd, type = 'page3') {
      const customerId = window.SHOPIFY_CUSTOMER.id;
 

    if (!customerId) {
    return;
    }

    const apiUrl = "https://tag-express.vercel.app/api/tag"; 

    fetch(apiUrl, {
    method: "POST",
    headers: {
        "Content-Type": "application/json"
    },
    body: JSON.stringify({
        customerId: customerId,
        tag: tagToAdd
    })
    })
    .then(response => response.json())
    .then(data => {
    console.log("打标结果:", data);
    })
    .catch(error => {
    console.error("网络错误:", error);
    }).finally(() => {

    })
}
function removeTagFromCustomer(tagToRemove) {
      const customerId = window.SHOPIFY_CUSTOMER.id;

    if (!customerId) return;

    const apiUrl = "https://tag-express.vercel.app/api/tag"; 

    fetch(apiUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        customerId: customerId,
        tag: tagToRemove,
        action: "remove" // 🌟 关键：这里传 remove
    })
    })
    .then(res => res.json())
    .then(data => {
    if(data.success) {
        console.log("标签移除成功");

    } else {
        console.error("移除失败", data);
    }
    });
}


const GIFT_VALIDATION_ENDPOINT = 'https://api.kemimoto.com/api/product/feeGiftProductId';

async function validateGiftProductFromIds(productIds) {
  if (!Array.isArray(productIds) || !productIds.length) return null;

  if (!GIFT_VALIDATION_ENDPOINT) {
    return null;
  }

  try {
    const response = await fetch(GIFT_VALIDATION_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        productIds: productIds
      })
    });

    if (!response.ok) return null;
    const payload = await response.json();
    const productId =
      payload && payload.data 
        ? payload.data
        : null;

    return productId ? productId : null;
  } catch (error) {
    console.warn('[gift-guard] validate request failed', error);
    return null;
  }
}

async function cleanupGiftFromCartOutsideBeta() {
  var pathname = String(window.location.pathname || '');
  if (pathname.indexOf('/pages/1000modfund') !== -1) {
    return;
  }
  try {
    const cartResponse = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    if (!cartResponse.ok) return;
    const cart = await cartResponse.json();
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    if (!items.length) return;
    const productIdSet = {};
    items.forEach(function(item) {
      if (item && item.product_id !== undefined && item.product_id !== null) {
        productIdSet[String(item.product_id)] = true;
      }
    });

    const productIds = Object.keys(productIdSet);
    if (!productIds.length) return;

    const giftProductId = await validateGiftProductFromIds(productIds);
    if (!giftProductId) return;
    const giftItem = items.find(function(item) {
      return item.product_id === giftProductId;
    });
    if (!giftItem || !giftItem.key) return;
    const removeResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        updates: (function() {
          var map = {};
          map[giftItem.key] = 0;
          return map;
        })()
      })
    });

    if (!removeResponse.ok) return;
  } catch (error) {
    console.warn('[gift-guard] cleanup failed', error);
  }
}

let __giftCleanupInFlight = false;

function runCleanupGiftFromCartOutsideBeta(trigger) {
  if (__giftCleanupInFlight) return;
  __giftCleanupInFlight = true;

  Promise.resolve()
    .then(function() {
      if (!GIFT_VALIDATION_ENDPOINT) {
        console.warn('[gift-guard] skipped: validation endpoint is not configured yet');
        return;
      }
      return cleanupGiftFromCartOutsideBeta();
    })
    .catch(function(error) {
      console.warn('[gift-guard] run failed on trigger:', trigger, error);
    })
    .finally(function() {
      __giftCleanupInFlight = false;
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    runCleanupGiftFromCartOutsideBeta('DOMContentLoaded');
  });
} else {
  runCleanupGiftFromCartOutsideBeta('readyState:' + document.readyState);
}

window.addEventListener('pageshow', function() {
  runCleanupGiftFromCartOutsideBeta('pageshow');
});

document.addEventListener('shopify:section:load', function() {
  runCleanupGiftFromCartOutsideBeta('shopify:section:load');
});
